import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { Extension } from "../_types/extension";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root',
})

export class ExtensionsService extends Service<Extension> {
  public override type = 'extension';
  public override url = 'Voip/extensions'; 
  
  public findFreeExtension(): Observable<any> {
    return this.http.get<any>(`${this.getAPIUrl()}/find-free-extension`);
  }

}
